import { useEffect, useRef, useState } from 'react';
import { UnauthedNavbar } from './UnauthedNavbar';

export const UnauthedPageWithNavbar = (props: React.PropsWithChildren) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const sidebarRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const hideSidebar = (e: MouseEvent) => {
      if (isSidebarOpen && !e.composedPath().includes(sidebarRef.current as HTMLDivElement)) {
        setIsSidebarOpen(false);
      }
    };

    document.addEventListener('click', hideSidebar, true);
    return () => document.removeEventListener('click', hideSidebar, true);
  }, [isSidebarOpen]);
  return (
    <div className='h-screen overflow-y-scroll'>
      <UnauthedNavbar
        isSidebarOpen={isSidebarOpen}
        setIsSidebarOpen={setIsSidebarOpen}
        sidebarRef={sidebarRef}
      />
      {props.children}
    </div>
  );
};
